import { createFileRoute } from "@tanstack/react-router"

import { FreigabenUebersichtPage } from "@/components/admin/auswertung/freigaben-uebersicht-page"

export const Route = createFileRoute("/_app/admin/freigaben")({
  component: FreigabenUebersichtPage,
})
